import React from 'react';
import { isBotApp, getStepsPreview } from '../../../utils/toolAppSubtype';

/**
 * For bot Apps: show how-to steps in place of the description on Discover cards.
 * Falls back to description if no steps are configured.
 */
const ToolCardDescriptionOrSteps = ({ tool, maxSteps = 3, className = 'garage-tool-description' }) => {
  const steps = isBotApp(tool) ? getStepsPreview(tool.steps, maxSteps) : [];

  if (steps.length > 0) {
    return (
      <ol className={`garage-tool-steps-preview ${className}`.trim()}>
        {steps.map((step, idx) => (
          <li key={idx}>
            <span className="garage-tool-step-num">{idx + 1}.</span>
            <span className="garage-tool-step-text">{step}</span>
          </li>
        ))}
      </ol>
    );
  }

  return <p className={className}>{tool.description}</p>;
};

export default ToolCardDescriptionOrSteps;
